export const types = {
    SET_GET_PAYMENT_METHOD: '[WALLET] SET GET PAYMENT METHOD',
    SET_GET_PAYMENT_METHOD_BY_ID: '[WALLET] SET GET PAYMENT METHOD BY ID'
}